import type { MailboxInfo } from 'owa-client-types';
import { ShouldEnableCopilotChat } from 'owa-bpos-utils';

export function isImmersiveBizChatEnabled(mailboxInfo?: MailboxInfo): boolean {
    return !!ShouldEnableCopilotChat(mailboxInfo);
}
